import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {getAllPayments} from '../actions';
import {Box, Pagination, Typography} from '@mui/material';
import PaymentsReportTable from '../components/CustomTables/PaymentsReportTable';
import {Filters} from '../components';
import useFilters from '../utils/useFilters';

// Payments have no elevator filter; require a project, entrance, customer or date range
// before loading anything (the unfiltered list is the whole payments table).
const hasAnyFilter = f =>
  !!(f.buildingId || f.entranceId || f.customerId || f.startTime);

const AllPaymentsPage = () => {
  const dispatch = useDispatch();
  const filters = useFilters(val => {
    if (hasAnyFilter(val)) dispatch(getAllPayments(val));
  });
  const hasFilter = hasAnyFilter(filters.filters);
  const {paymentsLoading, allPayments, allPaymentsPage, allPaymentsTotalPages} =
    useSelector(s => s.payments);

  const onPageChange = (e, value) => {
    dispatch(getAllPayments({page: value, ...filters.filters}));
  };

  return (
    <>
      <Filters
        withBuilding
        withEntrance
        withCustomer
        withDateRange
        position="left"
        {...filters}
      />
      {hasFilter ? (
        <PaymentsReportTable payments={allPayments} loading={paymentsLoading} />
      ) : (
        <Box mt="2rem" textAlign="center">
          <Typography color="textSecondary">
            Select a project, entrance, customer or date range to see payments.
          </Typography>
        </Box>
      )}
      {hasFilter && allPaymentsTotalPages > 1 && (
        <Box mt="1rem" display="flex" justifyContent="center">
          <Pagination
            count={allPaymentsTotalPages}
            page={allPaymentsPage}
            onChange={onPageChange}
          />
        </Box>
      )}
    </>
  );
};

export default AllPaymentsPage;
